import { Text } from 'ui-kit/typography'
import { BuildingBlocks } from 'routes/components/Features/BuildingBlocks'
import classes from './DifferenceBlocks.module.scss'

export const DifferenceBlocks = () => {
  return (
    <article className={classes.article}>
      <div className={classes.heading}>
        <Text size={'lg'} center balance className={classes.tagline}>
          Select from a library of universal building blocks
        </Text>
        <Text size={'lg'} center balance className={classes.subtitle}>
          95% of your integrations consist of the same building blocks as
          everyone else's. Do not reinvent the wheel - assemble your
          integrations from well-engineered and battle-tested components that
          work with all the external apps at once.
        </Text>
      </div>

      <BuildingBlocks />
    </article>
  )
}
